import * as Sentry from '@sentry/react';

// Requests persistent storage (design D17 / task 2.6) so the browser is far
// less likely to evict IndexedDB (the Dexie outbox, added from slice 3
// onward) under storage pressure — losing queued offline check-ins would be
// a silent data-loss bug, not just a UX annoyance. Called once at first
// login (see LoginPage.tsx). The outcome is tagged on Sentry so we can see
// real-world grant rates (iOS Safari in particular grants this far less
// often than Chromium) without needing a dedicated analytics event.
export async function requestPersistentStorage(): Promise<boolean> {
  const granted = (await navigator.storage?.persist?.()) ?? false;
  Sentry.setTag('offline.persistGranted', granted);
  return granted;
}
